import { useContext } from 'react';
import { DetailFilterContext } from '../../context/DetailFilterContext';

export const useDetailFilterContext = () => {
  const context = useContext(DetailFilterContext);

  if (context.isProvided === false) {
    throw new Error(
      'useDetailFilterContext must be used within a DetailFilterContextProvider'
    );
  }
  return context;
};
